import { __ } from '../../../translations';

export const getChannelTypes = (genres: any[]) => {
    return (
        genres.map((genre) => ({
            name: genre.value,
            label: `${__(genre.label)} (${genre.count})`,
            count: genre?.count,
        })) || []
    );
};

export const getSearchedChannels = (searchChannels: any[]) => {
    return searchChannels.map((channel: any, index: number) => ({
        // Display properties for the search UI
        index,
        logoSrc: channel.logo,
        title: channel.title,
        channelNo: channel.channelNumber,
        id: channel.id,
        locked: channel.locked,

        // Include the full channel object for selection handling
        ...channel, // Spread all original channel properties

        // Ensure display properties take precedence
        originalChannel: channel, // Keep reference to full channel
    }));
};

export const handleChannelSelect = (selected, query, onChannelSelectHandler, sendChannelSearchSelectEvent) => {
    if (selected) {
        // Use the full channel object if available, otherwise use selected
        const fullChannel = selected.originalChannel || selected;
        onChannelSelectHandler(fullChannel);
        sendChannelSearchSelectEvent(selected, query);
    }
};

export const calculateScrollLeft = (
    container: HTMLElement,
    element: HTMLElement,
    isRTL: boolean | undefined,
    offset: number
): number => {
    let targetScrollLeft: number;
    const scrollOffset = offset;

    const containerRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    const elementLeftRelativeToContainer = elementRect.left - containerRect.left;

    if (isRTL) {
        const elementRightRelativeToContainer = elementRect.right - containerRect.left;
        targetScrollLeft =
            container.scrollLeft + elementRightRelativeToContainer - container.clientWidth + scrollOffset;
    } else {
        targetScrollLeft = container.scrollLeft + elementLeftRelativeToContainer - scrollOffset;
    }

    const maxScrollLeft = container.scrollWidth - container.clientWidth;
    return Math.min(targetScrollLeft, maxScrollLeft);
};

export const isFutureProgram = (startTime: any, endTime: any) => {
    const currentTime = Date.now();
    return startTime > currentTime && endTime > currentTime;
};

/**
 * Recursively checks if the given HTML element or any of its ancestors with the class name containing 'stack'
 * has a `data-dragging` attribute set to `'true'`.
 *
 * @param target - The HTML element to start checking from.
 * @returns A tuple where the first element is a boolean indicating the dragging status,
 * and the second element is the HTMLElement with the class name containing 'stack'.
 */
export const getDraggingStatus = (target: HTMLElement): any => {
    if (target.className.indexOf('stack') !== -1) {
        if (target.dataset.dragging) {
            return [target.dataset.dragging === 'true', target];
        }
        return [false, target];
    }
    if (target.parentElement) {
        return getDraggingStatus(target.parentElement);
    }
    return [false, target];
};

export const onClickHandler = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
};
